<bb-period-selector-ui
  periodSize="month"
  [periodStart]="startDate"
  [periodEnd]="endDate"
  [periodFormatters]="periodFormatters"
></bb-period-selector-ui>
